module.exports = __webpack_public_path__ + "img/watering.066e8c49.jpg";